import CurrentBetsPage from "./current-bets-page";

export default CurrentBetsPage